import { PropertyBase } from './property-base.model';

export class PrintProperty extends PropertyBase {
  public prefix: string;
  constructor(data: any = {}) {
    super();
    this.title = data.title || 'Title';
    this.value = data.value || false;
    this.prefix = data.prefix || 'Disabled on Print';
  }
}
